// Bilingual content for Prime Collective — BG (default) / EN
export const translations = {
  bg: {
    nav: {
      home: "Начало",
      services: "Услуги",
      portfolio: "Портфолио",
      about: "За нас",
      contact: "Контакти",
      blog: "Блог",
      cta: "Свържи се",
    },
    hero: {
      tag: "Дигитална маркетинг агенция",
      headlineLine1: "Резултати, ",
      headlineLine2: "не обещания.",
      sub: "Изграждаме дигитални стратегии, които носят реален ръст — от SEO и реклами до съдържание, социални мрежи и бранд позициониране.",
      ctaPrimary: "Безплатна консултация",
      ctaSecondary: "Виж услугите",
      scroll: "Превърти надолу",
      since: "Активни от 2018",
    },
    metrics: {
      heading: "Числата говорят",
      items: [
        { value: "150+", label: "Реализирани проекта" },
        { value: "80+", label: "Активни клиенти" },
        { value: "7+", label: "Години опит" },
        { value: "3.8×", label: "Среден ROI" },
        { value: "+124%", label: "Растеж на трафик" },
        { value: "+67%", label: "Конверсии" },
      ],
    },
    marquee: [
      "Social Media Marketing",
      "SEO Optimization",
      "Google Ads / PPC",
      "Branding & Identity",
      "Web Design",
      "Content Strategy",
    ],
    services: {
      tag: "01 — Услуги",
      heading: "Дигитални услуги, проектирани да растат с твоя бизнес",
      seeAll: "Виж всички услуги",
      learnMore: "Научи повече",
      list: [
        {
          num: "01",
          title: "Social Media Marketing",
          desc: "Изграждаме и управляваме стратегическо присъствие в социалните мрежи, което увеличава разпознаваемостта на бранда и води до реални запитвания и продажби.",
          bullets: [
            "Facebook, Instagram, TikTok управление",
            "Създаване на съдържание и визии",
            "Анализ на аудитория и конкуренция",
            "Ежемесечни отчети с KPI",
          ],
        },
        {
          num: "02",
          title: "SEO Оптимизация",
          desc: "Класираме сайта ти на първа страница в Google и привличаме органичен трафик с висока конверсия.",
          bullets: [
            "Технически SEO одит",
            "On-page и Off-page оптимизация",
            "Изграждане на линкове",
            "Локална SEO стратегия",
          ],
        },
        {
          num: "03",
          title: "Performance Marketing",
          desc: "Управляваме рекламни кампании в Google и Meta с измерим ROI и оптимизирани разходи за клик.",
          bullets: [
            "Google Search & Display реклами",
            "YouTube реклами",
            "Ремаркетинг кампании",
            "A/B тестване",
          ],
        },
        {
          num: "04",
          title: "Branding & Identity",
          desc: "Изграждаме бранд идентичност, която отличава бизнеса ти и изгражда доверие сред аудиторията.",
          bullets: [
            "Лого и визуална идентичност",
            "Brand guidelines",
            "Маркетинг материали",
            "Стратегия за позициониране",
          ],
        },
        {
          num: "05",
          title: "Уеб дизайн & Разработка",
          desc: "Проектираме и разработваме уебсайтове, които комбинират модерен дизайн с висока ефективност.",
          bullets: [
            "UI/UX дизайн",
            "Разработка на WordPress / Next.js",
            "Оптимизация за скорост",
            "Поддръжка и обновления",
          ],
        },
      ],
    },
    why: {
      tag: "02 — Защо ние",
      heading: "Какво ни отличава от стандартните агенции",
      items: [
        { stat: "30-60", unit: "дни", title: "Бързи резултати", desc: "Първите резултати се виждат в рамките на 30-60 дни — не след 6 месеца." },
        { stat: "100%", unit: "прозрачност", title: "Data-driven подход", desc: "Всяко решение се базира на данни и A/B тестове, не на предположения." },
        { stat: "24/7", unit: "достъп", title: "Персонален подход", desc: "Работиш директно с екипа — бърза комуникация, ясни отговори, реални решения." },
      ],
      compareLeft: {
        title: "Традиционни агенции",
        bullets: [
          "Дълги договори (12+ месеца)",
          "Скрити такси и доплащания",
          "Бавна комуникация",
          "Generic стратегии",
        ],
      },
      compareRight: {
        title: "Prime Collective",
        bullets: [
          "Гъвкави месечни пакети",
          "Прозрачно ценообразуване",
          "Отговор в рамките на 24ч",
          "Персонализирани стратегии",
        ],
      },
    },
    process: {
      tag: "03 — Нашият процес",
      heading: "Стъпките към успеха",
      sub: "Структуриран процес, който води до измерими резултати.",
      steps: [
        { num: "01", title: "Анализ", desc: "Изследваме бизнеса, конкуренцията и целевата аудитория." },
        { num: "02", title: "Стратегия", desc: "Изграждаме персонализиран план с ясни KPI и цели." },
        { num: "03", title: "Изпълнение", desc: "Реализираме стратегията с прецизност и внимание към детайла." },
        { num: "04", title: "Оптимизация", desc: "Непрекъснато анализираме и подобряваме резултатите." },
      ],
    },
    portfolio: {
      tag: "01 — Портфолио",
      heading: "Бизнеси, които вече ни гласуваха доверие",
      seeAll: "Виж всички проекти",
      filters: ["Всички", "SEO", "Web Design", "Social Media", "Branding"],
    },
    pricing: {
      tag: "02 — Пакети",
      heading: "Изберете подходящия за вас",
      sub: "Прозрачно ценообразуване. Без скрити такси. Без дълги договори.",
      currency: "лв/мес",
      mostPopular: "НАЙ-ПОПУЛЯРЕН",
      cta: "Поискай оферта",
      plans: [
        {
          name: "Стартер",
          tagline: "Първа стъпка към дигиталния растеж",
          desc: "Идеален за малки бизнеси, които тепърва стартират онлайн присъствието си.",
          features: ["1 социална мрежа", "До 8 публикации/месец", "Ежемесечен отчет", "Имейл поддръжка"],
        },
        {
          name: "Професионал",
          tagline: "Пълна стратегия за растеж",
          desc: "За бизнеси, които искат цялостен дигитален маркетинг и видими резултати.",
          features: ["3 социални мрежи", "SEO оптимизация", "Google Ads управление", "Ежеседмични отчети", "Приоритетна поддръжка"],
        },
        {
          name: "Ентерпрайз",
          tagline: "Изцяло по ваша мярка",
          desc: "За големи компании с нужда от дедикиран екип и персонализирана стратегия.",
          features: ["Пълен пакет услуги", "Персонален мениджър", "Дедикиран екип", "AI маркетинг инструменти", "24/7 поддръжка"],
        },
      ],
    },
    blog: {
      tag: "01 — Блог",
      heading: "Последни статии",
      seeAll: "Виж всички статии",
      readMore: "Прочети повече",
      posts: [
        { cat: "Social Media", time: "6 мин", title: "Как да изградим успешна стратегия за Social Media", desc: "Стъпка по стъпка ръководство за изграждане на стратегия в социалните мрежи, която генерира реални резултати." },
        { cat: "Google Ads", time: "10 мин", title: "Google Ads vs Facebook Ads: кое е по-добро за вашия бизнес?", desc: "Подробно сравнение на двете платформи — предимства, недостатъци и кога да използвате всяка от тях." },
        { cat: "Уеб дизайн", time: "5 мин", title: "5 тренда в уеб дизайна за 2026", desc: "Кои са дизайн тенденциите, които ще оформят уеб пространството през 2026 и как да ги приложите." },
      ],
    },
    finalCta: {
      tag: "Безплатна консултация",
      headlineLine1: "Готов ли си",
      headlineLine2: "за растеж?",
      sub: "Разкажи ни за бизнеса си. Ще получиш персонализирана стратегия в рамките на 48 часа.",
      ctaPortfolio: "Виж портфолио",
      ctaContact: "Свържи се с нас",
    },
    contact: {
      tag: "01 — Контакти",
      heading: "Нека поговорим",
      sub: "Разкажете ни за вашия бизнес. Ще изготвим персонализирана стратегия за вас.",
      stats: [
        { v: "24ч", l: "Отговор" },
        { v: "80+", l: "Клиенти" },
        { v: "100%", l: "Прозрачност" },
      ],
      info: {
        emailLabel: "Email",
        phoneLabel: "Телефон",
        locationLabel: "Локация",
        location: "София, България",
        hoursLabel: "Работно време",
        hours: "Пон–Пет, 09:00–18:00",
      },
      form: {
        title: "Разкажете ни за вашия проект",
        sub: "Отговаряме в рамките на 24 часа.",
        name: "Вашето име",
        email: "Имейл адрес",
        phone: "Телефон",
        service: "Интересувате се от",
        servicePlaceholder: "Изберете услуга",
        message: "Съобщение",
        submit: "Изпрати запитване",
        services: ["Social Media Marketing", "SEO Оптимизация", "Google Ads / PPC", "Branding", "Уеб дизайн", "Пакет услуги"],
        success: "Благодарим! Ще се свържем с вас в рамките на 24 часа.",
        whatYouGet: "Какво получавате",
        perks: ["Безплатна 30-мин консултация", "Персонализирана стратегия", "Анализ на конкуренцията", "Прозрачно ценообразуване"],
      },
    },
    about: {
      tag: "01 — За нас",
      heading: "Колектив от стратези, дизайнери и аналитици",
      sub: "Prime Collective е независима дигитална агенция, която помага на български и международни бизнеси да растат онлайн чрез измерими стратегии, не на базата на догадки.",
      manifestoTitle: "Манифест",
      manifesto: [
        "Не правим маркетинг заради маркетинга. Правим го заради приходите ви.",
        "Прозрачност не е опция — тя е стандарт.",
        "Всяко решение трябва да издържи теста на данните.",
        "Ако не работи — спираме. Ако работи — мащабираме.",
      ],
      teamTag: "Екипът",
      teamHeading: "Хората зад резултатите",
    },
    footer: {
      tag: "Дигитална маркетинг агенция",
      navTitle: "Навигация",
      servicesTitle: "Услуги",
      contactTitle: "Контакти",
      socialTitle: "Социални",
      cta: "Готов за растеж?",
      ctaBtn: "Започни проект",
      copyright: "© 2026 Prime Collective. Всички права запазени.",
      privacy: "Поверителност",
      terms: "Общи условия",
    },
    common: {
      back: "Назад",
      results: "Резултати",
      tags: "Тагове",
    },
  },
  en: {
    nav: {
      home: "Home",
      services: "Services",
      portfolio: "Work",
      about: "About",
      contact: "Contact",
      blog: "Journal",
      cta: "Get in touch",
    },
    hero: {
      tag: "Digital Marketing Agency",
      headlineLine1: "Results, ",
      headlineLine2: "not promises.",
      sub: "We build digital strategies that drive real growth — from SEO and ads to content, social, and brand positioning.",
      ctaPrimary: "Free consultation",
      ctaSecondary: "Explore services",
      scroll: "Scroll down",
      since: "Active since 2018",
    },
    metrics: {
      heading: "The numbers speak",
      items: [
        { value: "150+", label: "Projects delivered" },
        { value: "80+", label: "Active clients" },
        { value: "7+", label: "Years in business" },
        { value: "3.8×", label: "Average ROI" },
        { value: "+124%", label: "Traffic growth" },
        { value: "+67%", label: "Conversion lift" },
      ],
    },
    marquee: [
      "Social Media Marketing",
      "SEO Optimization",
      "Google Ads / PPC",
      "Branding & Identity",
      "Web Design",
      "Content Strategy",
    ],
    services: {
      tag: "01 — Services",
      heading: "Digital services engineered to scale your business",
      seeAll: "See all services",
      learnMore: "Learn more",
      list: [
        {
          num: "01",
          title: "Social Media Marketing",
          desc: "We build and manage strategic social presence that grows brand awareness, engages your audience, and converts followers into paying customers.",
          bullets: [
            "Facebook, Instagram, TikTok management",
            "Content & creative production",
            "Audience & competitor analysis",
            "Monthly KPI reports",
          ],
        },
        {
          num: "02",
          title: "SEO Optimization",
          desc: "We rank your site on Google's first page and capture high-intent organic traffic that converts.",
          bullets: [
            "Technical SEO audit",
            "On-page & off-page optimization",
            "Authority link building",
            "Local SEO strategy",
          ],
        },
        {
          num: "03",
          title: "Performance Marketing",
          desc: "We run Google & Meta Ads campaigns with measurable ROI and tightly optimized cost per click.",
          bullets: [
            "Google Search & Display ads",
            "YouTube ads",
            "Remarketing campaigns",
            "A/B testing",
          ],
        },
        {
          num: "04",
          title: "Branding & Identity",
          desc: "We craft brand identities that stand out and build long-term trust with your audience.",
          bullets: [
            "Logo & visual identity",
            "Brand guidelines",
            "Marketing collateral",
            "Positioning strategy",
          ],
        },
        {
          num: "05",
          title: "Web Design & Development",
          desc: "Modern, fast websites that look stunning and convert visitors into customers.",
          bullets: [
            "UI/UX design",
            "WordPress / Next.js development",
            "Performance optimization",
            "Ongoing support",
          ],
        },
      ],
    },
    why: {
      tag: "02 — Why us",
      heading: "What sets us apart from typical agencies",
      items: [
        { stat: "30-60", unit: "days", title: "Fast results", desc: "First results within 30-60 days — not 6 months down the line." },
        { stat: "100%", unit: "transparency", title: "Data-driven", desc: "Every decision is grounded in data and A/B tests — not guesswork." },
        { stat: "24/7", unit: "access", title: "Personal touch", desc: "Direct line to the team — fast comms, clear answers, real solutions." },
      ],
      compareLeft: {
        title: "Traditional agencies",
        bullets: [
          "Long contracts (12+ months)",
          "Hidden fees & upcharges",
          "Slow communication",
          "Generic strategies",
        ],
      },
      compareRight: {
        title: "Prime Collective",
        bullets: [
          "Flexible monthly packages",
          "Transparent pricing",
          "Reply within 24h",
          "Custom strategies",
        ],
      },
    },
    process: {
      tag: "03 — Our process",
      heading: "Steps to success",
      sub: "A structured process that delivers measurable outcomes.",
      steps: [
        { num: "01", title: "Discovery", desc: "We research your business, competition, and target audience." },
        { num: "02", title: "Strategy", desc: "We craft a custom plan with clear KPIs and goals." },
        { num: "03", title: "Execution", desc: "We deliver with precision and meticulous attention to detail." },
        { num: "04", title: "Optimization", desc: "We continuously analyze and improve performance." },
      ],
    },
    portfolio: {
      tag: "01 — Work",
      heading: "Brands that already trust us",
      seeAll: "See all projects",
      filters: ["All", "SEO", "Web Design", "Social Media", "Branding"],
    },
    pricing: {
      tag: "02 — Packages",
      heading: "Pick the right fit",
      sub: "Transparent pricing. No hidden fees. No long contracts.",
      currency: "EUR/mo",
      mostPopular: "MOST POPULAR",
      cta: "Request a quote",
      plans: [
        {
          name: "Starter",
          tagline: "Your first step into digital growth",
          desc: "Perfect for small businesses just getting their online presence going.",
          features: ["1 social channel", "Up to 8 posts/month", "Monthly report", "Email support"],
        },
        {
          name: "Professional",
          tagline: "Full-stack growth strategy",
          desc: "For businesses that want a complete digital marketing system with measurable results.",
          features: ["3 social channels", "SEO optimization", "Google Ads management", "Weekly reports", "Priority support"],
        },
        {
          name: "Enterprise",
          tagline: "Tailored entirely to you",
          desc: "For large companies that need a dedicated team and custom strategy.",
          features: ["Full service stack", "Dedicated manager", "Dedicated team", "AI marketing tools", "24/7 support"],
        },
      ],
    },
    blog: {
      tag: "01 — Journal",
      heading: "Latest insights",
      seeAll: "See all articles",
      readMore: "Read more",
      posts: [
        { cat: "Social Media", time: "6 min", title: "How to build a winning Social Media strategy", desc: "A step-by-step guide to building a social media strategy that drives real business results." },
        { cat: "Google Ads", time: "10 min", title: "Google Ads vs Facebook Ads: which is better for you?", desc: "A deep comparison of the two platforms — pros, cons, and when to use each." },
        { cat: "Web Design", time: "5 min", title: "5 web design trends for 2026", desc: "The design trends that will define the web in 2026 — and how to apply them." },
      ],
    },
    finalCta: {
      tag: "Free consultation",
      headlineLine1: "Ready to",
      headlineLine2: "scale up?",
      sub: "Tell us about your business. You'll receive a custom strategy within 48 hours.",
      ctaPortfolio: "View portfolio",
      ctaContact: "Get in touch",
    },
    contact: {
      tag: "01 — Contact",
      heading: "Let's talk",
      sub: "Tell us about your business. We'll prepare a custom strategy for you.",
      stats: [
        { v: "24h", l: "Response time" },
        { v: "80+", l: "Clients" },
        { v: "100%", l: "Transparency" },
      ],
      info: {
        emailLabel: "Email",
        phoneLabel: "Phone",
        locationLabel: "Location",
        location: "Sofia, Bulgaria",
        hoursLabel: "Office hours",
        hours: "Mon–Fri, 09:00–18:00",
      },
      form: {
        title: "Tell us about your project",
        sub: "We respond within 24 hours.",
        name: "Your name",
        email: "Email address",
        phone: "Phone",
        service: "Interested in",
        servicePlaceholder: "Pick a service",
        message: "Message",
        submit: "Send inquiry",
        services: ["Social Media Marketing", "SEO Optimization", "Google Ads / PPC", "Branding", "Web Design", "Service bundle"],
        success: "Thanks! We'll be in touch within 24 hours.",
        whatYouGet: "What you get",
        perks: ["Free 30-min consultation", "Custom strategy", "Competitor analysis", "Transparent pricing"],
      },
    },
    about: {
      tag: "01 — About",
      heading: "A collective of strategists, designers and analysts",
      sub: "Prime Collective is an independent digital agency helping Bulgarian and international businesses grow online through measurable strategies — never guesswork.",
      manifestoTitle: "Manifesto",
      manifesto: [
        "We don't do marketing for the sake of marketing. We do it for your revenue.",
        "Transparency isn't an option — it's a standard.",
        "Every decision must survive the test of data.",
        "If it doesn't work — we stop. If it works — we scale.",
      ],
      teamTag: "The team",
      teamHeading: "The people behind the results",
    },
    footer: {
      tag: "Digital marketing agency",
      navTitle: "Navigation",
      servicesTitle: "Services",
      contactTitle: "Contact",
      socialTitle: "Social",
      cta: "Ready for growth?",
      ctaBtn: "Start a project",
      copyright: "© 2026 Prime Collective. All rights reserved.",
      privacy: "Privacy",
      terms: "Terms",
    },
    common: {
      back: "Back",
      results: "Results",
      tags: "Tags",
    },
  },
};

// Static data shared across languages
export const portfolioProjects = [
  {
    slug: "documentor-bg",
    name: "DocumentorBG",
    category: "Software",
    tags: ["Social Media", "SEO"],
    image: "https://ygmthelolhwoxkvcvhcr.supabase.co/storage/v1/object/public/images/1776239013173-a47k9.jpeg",
    result: { bg: "+312% Заявки", en: "+312% Inquiries" },
    description: {
      bg: "Цялостна стратегия за SEO и социални мрежи за SaaS платформа за документи.",
      en: "Full SEO + social strategy for a documents SaaS platform.",
    },
  },
  {
    slug: "kasidi-2000",
    name: "Kasidi 2000",
    category: "Retail",
    tags: ["SEO", "Web Design"],
    image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?auto=format&fit=crop&w=1200&q=80",
    result: { bg: "+280% Органичен трафик", en: "+280% Organic traffic" },
    description: {
      bg: "Редизайн + локална SEO стратегия — троен ръст на органичните посещения.",
      en: "Redesign + local SEO — 3× growth in organic visits.",
    },
  },
  {
    slug: "bella-vita",
    name: "Bella Vita Restaurant",
    category: "F&B",
    tags: ["Web Design", "Social Media"],
    image: "https://ygmthelolhwoxkvcvhcr.supabase.co/storage/v1/object/public/images/1773328053760-ngidm4.png",
    result: { bg: "+220% Онлайн резервации", en: "+220% Online bookings" },
    description: {
      bg: "Уеб дизайн и Local SEO за ресторант — двойно повече резервации.",
      en: "Web design + local SEO for a restaurant — 2× bookings.",
    },
  },
  {
    slug: "autopro",
    name: "AutoPro",
    category: "Automotive",
    tags: ["Google Ads", "Branding"],
    image: "https://images.unsplash.com/photo-1503376780353-7e6692767b70?auto=format&fit=crop&w=1200&q=80",
    result: { bg: "−42% Цена на лийд", en: "−42% Cost per lead" },
    description: {
      bg: "Performance Marketing + ребрандинг за автомобилен сервиз.",
      en: "Performance marketing + rebranding for an auto service.",
    },
  },
  {
    slug: "medcenter",
    name: "MedCenter",
    category: "Healthcare",
    tags: ["SEO", "Branding"],
    image: "https://images.unsplash.com/photo-1631815589968-fdb09a223b1e?auto=format&fit=crop&w=1200&q=80",
    result: { bg: "+186% Записани часове", en: "+186% Bookings" },
    description: {
      bg: "Авторитетен бранд и SEO за медицински център — почти 3× повече часове.",
      en: "Authority brand + SEO for a medical center — nearly 3× appointments.",
    },
  },
  {
    slug: "buildpro",
    name: "BuildPro",
    category: "Construction",
    tags: ["Web Design", "Google Ads"],
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&w=1200&q=80",
    result: { bg: "+147% Запитвания", en: "+147% Inquiries" },
    description: {
      bg: "Премиум сайт + Performance Marketing за строителна фирма.",
      en: "Premium site + performance marketing for a construction firm.",
    },
  },
];

export const clientLogos = [
  "Casidi 2000",
  "Disa",
  "Documentor",
  "Docs Done",
  "AutoPro",
  "MedCenter",
  "CHML",
  "BuildPro",
  "UQL",
  "BuildMax",
];

export const teamMembers = [
  {
    name: "Стефан Димитров",
    role: { bg: "Основател & Стратегия", en: "Founder & Strategy" },
    image: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Мария Тодорова",
    role: { bg: "Креативен директор", en: "Creative Director" },
    image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=crop&w=600&q=80",
  },
  {
    name: "Иван Петров",
    role: { bg: "Performance Lead", en: "Performance Lead" },
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=600&q=80",
  },
];
